import { AbstractControl, ValidationErrors } from '@angular/forms';
import { convertErrorsToValidationErrors } from '@app/core/utils/errors';
import { ParcelDimensions } from '@app/ecsomag/models';
import { PackageSize, ShippingInfo } from '@app/models/prices';
import { validateBankAccountNumber, validateBankAccountHolder } from '@app/models/prices.validators';

export const calculatePackageSize = (shippingInfo: ShippingInfo, { width, length, height }: ParcelDimensions): PackageSize | undefined => {
	// console.groupCollapsed('calculatePackageSize', { width, length, height });
	const orderedLengths = [width, length, height].sort((a: number, b: number) => a - b);
	const sizeTwoSides = orderedLengths[0] + orderedLengths[2];
	const sizeCircumference = orderedLengths[2] + 2 * (orderedLengths[0] + orderedLengths[1]);
	// console.log({ width, length, height }, orderedLengths, sizeTwoSides, sizeCircumference);
	const matchingPackageSizes = [...shippingInfo.packageSizes]
		.sort((a: PackageSize, b: PackageSize) => a.sizeLimit - b.sizeLimit)
		.filter(packageSize => {
			// console.log(
			// 	packageSize.size, packageSize.sizeLimitType, packageSize.sizeLimit,
			// 	(packageSize.sizeLimitType === 'two_sides' ? sizeTwoSides : sizeCircumference) <= packageSize.sizeLimit
			// );
			switch (packageSize.sizeLimitType) {
				case 'two_sides':
					return packageSize.sizeLimit >= sizeTwoSides;
				case 'circumference':
					return packageSize.sizeLimit >= sizeCircumference;
			}
		});
	// console.log('matchingSizes:', matchingPackageSizes.map(s => s.size));
	const smallestMatchingPackageSize = matchingPackageSizes.shift();
	// console.log('smallestMatchingSize:', smallestMatchingPackageSize);
	// console.groupEnd();
	return smallestMatchingPackageSize;
};

// export const packageSizeCalculator = (
// 	shippingInfo$: Observable<ShippingInfo>,
// 	dimensions$: Observable<ParcelDimensions>,
// ) => combineLatest([
// 	shippingInfo$,
// 	dimensions$,
// ]).pipe(
// 	map(
// 		([
// 			shippingInfo,
// 			dimensions,
// 		]) => calculatePackageSize(
// 			shippingInfo,
// 			dimensions,
// 		)
// 	),
// );

// export const asyncParcelDimensionValidator = (shippingInfo$: Observable<ShippingInfo>, dimensionKey: ParcelDimensionKey, firstMileType: FirstMileType): AsyncValidatorFn =>
// (control: AbstractControl): Observable<ValidationErrors | null> => {
// 	return shippingInfo$.pipe(
// 		map(shippingInfo => {
// 			const dimensionValue = control?.value;

// 			return convertErrorsToValidationErrors(
// 				validateDimension(shippingInfo, { dimensionKey, dimensionValue, firstMileType })
// 			);
// 		}),
// 		first(),
// 		// tap(result => { console.log('asyncParcelDimensionValidator result', dimensionKey, result); })
// 	);
// };

// export const asyncPackageSizeValidator = (shippingInfo$: Observable<ShippingInfo>): AsyncValidatorFn =>
// (control: AbstractControl): Observable<ValidationErrors | null> => {
// 	return shippingInfo$.pipe(
// 		map(shippingInfo => {
// 			const dimensions = {
// 				width: control.get('width')?.value,
// 				length: control.get('length')?.value,
// 				height: control.get('height')?.value,
// 			};

// 			return convertErrorsToValidationErrors(
// 				validateSize(shippingInfo, { dimensions, firstMileType })
// 			);
// 		}),
// 		first(),
// 		// tap(result => { console.log('asyncPackageSizeValidator result', result); })
// 	);
// };

// export const asyncCODAmountValidator = (shippingInfo$: Observable<ShippingInfo>): AsyncValidatorFn =>
// (control: AbstractControl): Observable<ValidationErrors | null> => {
// 	return shippingInfo$.pipe(
// 		map(shippingInfo => {
// 			const codAmount = control?.value;

// 			return convertErrorsToValidationErrors(
// 				validateCODAmount(shippingInfo, { codAmount })
// 			);
// 		}),
// 		first(),
// 		// tap(result => { console.log('asyncCODAmountValidator result', result); })
// 	);
// };

export const bankAccountNumberValidator = (control: AbstractControl): ValidationErrors | null => {
	const bankAccountNumber = control?.value;

	return convertErrorsToValidationErrors(validateBankAccountNumber(bankAccountNumber));
};

export const bankAccountHolderValidator = (control: AbstractControl): ValidationErrors | null => {
	const bankAccountHolder = control?.value;

	return convertErrorsToValidationErrors(validateBankAccountHolder(bankAccountHolder));
};
